(function () {
  'use strict';

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'];

  (function captureUtm() {
    var qs = new URLSearchParams(location.search);
    UTM_KEYS.forEach(function (k) {
      var v = qs.get(k);
      if (v) { try { localStorage.setItem(k, v); } catch (e) { } }
    });
  })();

  function readUtm() {
    var out = {};
    UTM_KEYS.forEach(function (k) {
      var v;
      try { v = localStorage.getItem(k); } catch (e) { v = null; }
      if (v) { out[k] = v; }
    });
    return out;
  }

  /* ------------------------------------------------ i18n ---- */
  var I18N = {
    uk: {
      inputPh: 'Напишіть повідомлення…',
      cityPh: 'Наприклад: Київ',
      descPh: 'Коротко опишіть ситуацію…',
      namePh: 'Ваше імʼя',
      contactPh: '+380 … або email',
      fab: 'Опишіть проблему',
      fabGo: 'Повернутись до розмови',
      fabDone: 'Заявку прийнято',
      greet1: 'Вітаю! Я Андрій К., асистент у CONSULTANT. Допоможу розібратися в ситуації та підберу юриста саме під вашу справу.',
      greet2: 'Розкажіть своїми словами, що сталося — це займе хвилину.',
      areas: [
        { id: 'family', label: 'Сімейне право' },
        { id: 'criminal', label: 'Кримінальне право' },
        { id: 'labor', label: 'Трудове право' },
        { id: 'realestate', label: 'Нерухомість і земля' },
        { id: 'inheritance', label: 'Спадщина' },
        { id: 'accident', label: 'ДТП і страхування' },
        { id: 'business', label: 'Бізнес і договори' },
        { id: 'military', label: 'Військове право' },
        { id: 'other', label: 'Інше питання' }
      ],
      detected: function (a) { return 'Схоже, ваше питання стосується напряму «' + a + '». Все вірно?'; },
      yes: 'Так, вірно',
      pickOther: 'Обрати інший напрям',
      cantDetect: 'Дякую, я записав опис. Напишіть, будь ласка, до якої сфери це ближче: сімейне, кримінальне, трудове, нерухомість, спадщина, ДТП, бізнес чи військове право.',
      details: {
        family: { q: 'Уточніть, будь ласка, що саме сталося:', opts: ['Розлучення', 'Аліменти', 'Поділ майна', 'Опіка над дітьми', 'Інше'] },
        criminal: { q: 'Уточніть вашу роль у ситуації:', opts: ['Мене затримали або підозрюють', 'Я потерпілий', 'Обшук чи виклик на допит', 'Інше'] },
        labor: { q: 'Що саме сталося на роботі?', opts: ['Незаконне звільнення', 'Невиплата зарплати', 'Трудовий договір', 'Тиск чи мобінг', 'Інше'] },
        realestate: { q: 'Про що йдеться?', opts: ['Купівля-продаж', 'Оренда', 'Спір із забудовником', 'Земельні питання', 'Інше'] },
        inheritance: { q: 'Уточніть, будь ласка:', opts: ['Оформлення спадщини', 'Спір між спадкоємцями', 'Заповіт', 'Інше'] },
        accident: { q: 'Уточніть вашу ситуацію:', opts: ['Я потерпілий у ДТП', 'Мене визнають винуватцем', 'Спір зі страховою', 'Інше'] },
        business: { q: 'Що потрібно для бізнесу?', opts: ['Договори', 'Стягнення боргу', 'Реєстрація / корпоративні питання', 'Перевірки', 'Інше'] },
        military: { q: 'Уточніть, будь ласка, тему:', opts: ['Мобілізація і відстрочка', 'ТЦК і повістки', 'Виплати військовим', 'Інше'] }
      },
      urgencyQ: 'Наскільки терміново потрібна допомога?',
      urgency: ['Терміново — сьогодні-завтра', 'Цього тижня', 'Протягом місяця', 'Поки що консультація'],
      cityQ: 'У якому місті ви перебуваєте? Це потрібно, щоб підібрати юриста поруч.',
      cityBad: 'Напишіть, будь ласка, назву міста.',
      budgetQ: 'Який бюджет ви орієнтовно готові закласти на послуги юриста?',
      budget: ['До ₴5 000', '₴5 000 – 20 000', '₴20 000 – 50 000', 'Понад ₴50 000', 'Складно сказати'],
      descQ: 'Опишіть ситуацію двома-трьома реченнями — юрист одразу розумітиме контекст.',
      skip: 'Пропустити',
      analyzing: 'Аналізую вашу ситуацію…',
      analysis: function (a, city) {
        return 'Дякую! За описом це схоже на ситуацію, де важлива консультація юриста з напряму «' + a + '».\n\nУ базі CONSULTANT є юристи з досвідом саме таких справ' + (city ? ' у місті ' + city : '') + '.';
      },
      nameQ: 'Як до вас звертатися?',
      nameBad: 'Напишіть, будь ласка, ваше імʼя.',
      contactQ: function (n) { return n + ', залишіть телефон або email — підібраний юрист звʼяжеться з вами напряму.'; },
      contactBad: 'Схоже, у контакті помилка. Вкажіть телефон у форматі +380… або email.',
      summary: function (d) {
        var rows = ['✓ Напрям: ' + d.areaLabel];
        if (d.detail) rows.push('✓ Деталі: ' + d.detail);
        if (d.city) rows.push('✓ Місто: ' + d.city);
        if (d.urgency) rows.push('✓ Терміновість: ' + d.urgency);
        return 'Формую запит для підбору:\n' + rows.join('\n');
      },
      done: function (n) {
        return 'Дякуємо, ' + n + '! Ми проаналізували вашу ситуацію і вже підбираємо юриста з досвідом саме в таких справах.\n\nЗазвичай юрист звʼязується протягом 15–30 хвилин у робочий час.';
      },
      done2: 'Зараз відкриється коротке опитування з 4 питань — воно допоможе юристу краще підготуватися до розмови.',
      noted: 'Записав і передам юристу 👌',
      cbLabel: 'Передзвоніть мені',
      cbArea: 'Зворотний дзвінок',
      cbAsk: 'Звісно! Візьмемо контакти — і юрист передзвонить вам найближчим часом.',
      classify: {
        family: ['розлуч', 'алімент', 'шлюб', 'опік', 'дитин', 'дітей', 'поділ майна', 'чоловік', 'дружин'],
        criminal: ['кримінал', 'затрим', 'підозр', 'поліці', 'обшук', 'допит', 'вирок', 'суд по кримінал'],
        labor: ['звільн', 'зарплат', 'роботодав', 'трудов', 'на роботі', 'відпустк'],
        realestate: ['квартир', 'нерухом', 'земл', 'оренд', 'забудов', 'іпотек', 'будинок', 'житл'],
        inheritance: ['спадщ', 'спадок', 'заповіт', 'нотаріус'],
        accident: ['дтп', 'авар', 'страхов', 'відшкодув', 'збив'],
        business: ['договір', 'договор', 'бізнес', 'фоп', 'тов ', 'борг', 'контрагент', 'постачальник'],
        military: ['тцк', 'мобіліз', 'повістк', 'військов', 'сзч', 'відстрочк', 'влк']
      }
    },
    en: {
      inputPh: 'Type a message…',
      cityPh: 'e.g. Austin, TX',
      descPh: 'Briefly describe your situation…',
      namePh: 'Your name',
      contactPh: 'Phone or email',
      fab: 'Describe your problem',
      fabGo: 'Back to the chat',
      fabDone: 'Request received',
      greet1: "Hi! I'm the CONSULTANT AI assistant. I'll help organize the key details and connect you with a lawyer whose experience matches your situation.",
      greet2: 'Tell me in your own words what happened — it only takes a minute.',
      areas: [
        { id: 'family', label: 'Family Law' },
        { id: 'immigration', label: 'Immigration' },
        { id: 'injury', label: 'Personal Injury' },
        { id: 'criminal', label: 'Criminal Defense' },
        { id: 'employment', label: 'Employment Law' },
        { id: 'business', label: 'Business Law' },
        { id: 'realestate', label: 'Real Estate' },
        { id: 'estates', label: 'Estate Planning & Probate' },
        { id: 'other', label: 'Something Else' }
      ],
      detected: function (a) { return 'It sounds like this relates to ' + a + '. Is that right?'; },
      yes: "Yes, that's right",
      pickOther: 'Pick another area',
      cantDetect: "Thanks, I've noted that. Which area is it closest to: family law, immigration, personal injury, criminal defense, employment law, business law, real estate, or estate planning?",
      details: {
        family: { q: 'Could you clarify what this is about?', opts: ['Divorce', 'Child custody', 'Child support', 'Property division', 'Other'] },
        immigration: { q: 'What best describes your situation?', opts: ['Visa or green card', 'Deportation risk', 'Work authorization', 'Citizenship', 'Other'] },
        injury: { q: 'What kind of injury case is it?', opts: ['Car accident', 'Work injury', 'Medical', 'Insurance dispute', 'Other'] },
        criminal: { q: 'What best describes your situation?', opts: ['I was arrested or charged', 'Under investigation', "I'm a victim", 'Other'] },
        employment: { q: 'What happened at work?', opts: ['Wrongful termination', 'Unpaid wages', 'Discrimination', 'Contract review', 'Other'] },
        business: { q: 'What does your business need?', opts: ['Contracts', 'Debt collection', 'Formation & corporate', 'Disputes', 'Other'] },
        realestate: { q: 'What is this about?', opts: ['Buying or selling', 'Landlord-tenant', 'Eviction', 'Land use', 'Other'] },
        estates: { q: 'Could you clarify?', opts: ['Will or trust', 'Probate', 'Inheritance dispute', 'Other'] }
      },
      urgencyQ: 'How urgent is it?',
      urgency: ['Urgent — today or tomorrow', 'This week', 'Within a month', 'Just a consultation for now'],
      cityQ: 'What city and state are you in? We use it to match you with a lawyer nearby.',
      cityBad: 'Please type your city.',
      budgetQ: 'What budget do you roughly have in mind for legal help?',
      budget: ['Under $500', '$500 – 2,000', '$2,000 – 5,000', 'Over $5,000', 'Not sure yet'],
      descQ: 'Describe the situation in two or three sentences — the lawyer will get the context right away.',
      skip: 'Skip',
      analyzing: 'Analyzing your situation…',
      analysis: function (a, city) {
        return 'Thank you! Based on your description, this looks like a situation where advice from a ' + a + ' lawyer could be important.\n\nCONSULTANT has lawyers with experience in exactly this kind of case' + (city ? ' in ' + city : '') + '.';
      },
      nameQ: 'What should we call you?',
      nameBad: 'Please type your name.',
      contactQ: function (n) { return n + ', leave your phone or email — the matched lawyer will contact you directly.'; },
      contactBad: "That contact doesn't look right. Please enter a phone number or an email.",
      summary: function (d) {
        var rows = ['✓ Practice area: ' + d.areaLabel];
        if (d.detail) rows.push('✓ Details: ' + d.detail);
        if (d.city) rows.push('✓ Location: ' + d.city);
        if (d.urgency) rows.push('✓ Urgency: ' + d.urgency);
        return 'Building your matching request:\n' + rows.join('\n');
      },
      done: function (n) {
        return 'Thank you, ' + n + "! We've analyzed your situation and are already matching you with a lawyer experienced in cases like yours.\n\nA lawyer usually reaches out within 15–30 minutes during business hours.";
      },
      done2: "One more quick step — a short 4-question survey will open to help the lawyer prepare for your call.",
      noted: "Noted — I'll pass it to the lawyer 👌",
      cbLabel: 'Call me back',
      cbArea: 'Callback request',
      cbAsk: "Sure! Leave your contact details and a lawyer will call you back shortly.",
      classify: {
        family: ['divorc', 'custod', 'alimony', 'child support', 'marriage', 'spouse', 'wife', 'husband'],
        immigration: ['visa', 'green card', 'immigr', 'deport', 'citizen', 'asylum', 'uscis'],
        injury: ['accident', 'injur', 'crash', 'slip', 'hurt', 'insurance claim'],
        criminal: ['arrest', 'criminal', 'police', 'charge', 'dui', 'felony', 'misdemeanor'],
        employment: ['fired', 'wage', 'employer', 'discriminat', 'harass', 'laid off', 'overtime'],
        business: ['contract', 'business', 'llc', 'partner', 'debt', 'vendor', 'startup'],
        realestate: ['landlord', 'tenant', 'evict', 'lease', 'property', 'real estate', 'mortgage', 'house'],
        estates: ['will', 'estate', 'probate', 'inherit', 'trust']
      }
    }
  };

  var lang = (document.documentElement.lang || 'uk').slice(0, 2) === 'en' ? 'en' : 'uk';
  var L = I18N[lang];
  /* Сторінка подяки з квізом кваліфікації — своя для кожної мови */
  var THANKS_URL = (window.LEAD_CONFIG && window.LEAD_CONFIG.thanksUrl) ||
    (lang === 'en' ? 'thanks-en.html' : 'thanks.html');

  /* ------------------------------------------------ лід ---- */
  function getCaptchaToken() {
    var cfg = window.LEAD_CONFIG || {};
    // CAPTCHA is optional: with empty keys local development works normally.
    if (!cfg.captchaSiteKey) {
      return Promise.resolve(null);
    }
    if (!window.grecaptcha || !window.grecaptcha.execute) {
      return Promise.reject(new Error('reCAPTCHA is not available'));
    }

    return new Promise(function (resolve, reject) {
      var done = false;
      var timer = setTimeout(function () {
        if (!done) { done = true; reject(new Error('reCAPTCHA timeout')); }
      }, 10000);

      window.grecaptcha.ready(function () {
        window.grecaptcha.execute(cfg.captchaSiteKey, { action: cfg.captchaAction || 'lead' })
          .then(function (token) {
            if (done) return;
            done = true;
            clearTimeout(timer);
            if (token) resolve(token);
            else reject(new Error('Empty reCAPTCHA token'));
          })
          .catch(function (error) {
            if (done) return;
            done = true;
            clearTimeout(timer);
            reject(error);
          });
      });
    });
  }

  function verifyCaptchaOnServer(token) {
    var cfg = window.LEAD_CONFIG || {};
    if (!cfg.captchaAjaxUrl) return Promise.reject(new Error('Captcha verification URL is missing'));

    var body = new URLSearchParams();
    body.set('action', 'ira_verify_lead_captcha');
    body.set('captcha_token', token);

    return fetch(cfg.captchaAjaxUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: body.toString(),
      credentials: 'same-origin'
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok || !data.success) {
          throw new Error('reCAPTCHA server verification failed');
        }
        return true;
      });
    });
  }

  function submitLead(lead) {
    /* Звʼязка для квіза кваліфікації на сторінці подяки: той самий id
       їде в ліді та лежить у sessionStorage — відповіді доповнюють
       саме цей лід, нового не створюється. */
    var leadRef = 'L-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
    lead.lead_ref = leadRef;
    try { sessionStorage.setItem('clm_consultant_lead_ref', leadRef); } catch (e) { }
    lead.locale = lang;
    lead.page = location.pathname;
    lead.ts = new Date().toISOString();
    lead.utm = readUtm();

    return getCaptchaToken()
      .then(function (token) {
        if (!token) return true;
        lead.captcha_action = (window.LEAD_CONFIG && window.LEAD_CONFIG.captchaAction) || 'lead';
        return verifyCaptchaOnServer(token);
      })
      .then(function () {
        console.info('[CONSULTANT lead]', lead);
        try {
          var key = 'clm_leads';
          var arr = JSON.parse(localStorage.getItem(key) || '[]');
          arr.push(lead);
          localStorage.setItem(key, JSON.stringify(arr));
        } catch (e) { /* приватний режим */ }

        if (window.LEAD_ENDPOINT) {
          try {
            fetch(window.LEAD_ENDPOINT, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(lead),
              keepalive: true
            }).catch(function () { });
          } catch (e) { }
        }
        if (window.dataLayer) window.dataLayer.push({ event: 'generate_lead', lead_source: lead.source });
        return true;
      });
  }

  function isContact(v) {
    v = String(v).trim();
    if (/\S+@\S+\.\S+/.test(v)) return true;
    var digits = (v.match(/\d/g) || []).length;
    return digits >= 9 && /^[+\d\s\-().]+$/.test(v);
  }

  /* ------------------------------------------------ чат ---- */
  var chat = document.getElementById('chat');
  if (!chat) return;

  var log = document.getElementById('chatLog');
  var quick = document.getElementById('chatQuick');
  var form = document.getElementById('chatForm');
  var input = document.getElementById('chatText');
  var bar = document.getElementById('chatBar');
  var fab = document.getElementById('chatFab');
  var fabLabel = document.getElementById('chatFabLabel');
  var fabDot = document.getElementById('chatFabDot');
  var minBtn = document.getElementById('chatMin');

  var state = {
    step: 'area',            // area → confirm → detail → urgency → city → budget → describe → name → contact → done
    started: false,          // користувач щось відповів
    open: false,             // мобільна фулскрін-панель відкрита
    deskOpen: true,          // десктопна панель розгорнута (як у v8 — відкрита одразу)
    wide: false,             // десктоп: збільшений стан із затемненням сторінки
    busy: false,             // бот «друкує»
    data: {}
  };
  var TOTAL_STEPS = 8;
  var stepsDone = 0;

  function progress() {
    stepsDone += 1;
    if (bar) bar.style.width = Math.min(100, Math.round(stepsDone / TOTAL_STEPS * 100)) + '%';
  }

  function scrollLog() { log.scrollTop = log.scrollHeight; }

  /* Кнопки швидких відповідей живуть у самому лозі, одразу після
     останнього повідомлення (як у v8), а не окремим рядком знизу */
  log.appendChild(quick);

  /* Час повідомлення (HH:MM) — як у чаті v8 */
  function stampTime(el) {
    var d = new Date();
    var t = document.createElement('i');
    t.className = 'msg-time';
    t.textContent = ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2);
    el.appendChild(t);
  }

  function addMsg(cls, text) {
    var el = document.createElement('div');
    el.className = 'msg ' + cls;
    el.textContent = text;
    stampTime(el);
    log.appendChild(el);
    log.appendChild(quick); // кнопки завжди під останнім повідомленням
    scrollLog();
    return el;
  }

  function userSay(text) { addMsg('msg--user', text); }

  function botSay(text, delay) {
    state.busy = true;
    return new Promise(function (resolve) {
      var t = document.createElement('div');
      t.className = 'msg msg--bot msg--typing';
      t.innerHTML = '<i></i><i></i><i></i>';
      log.appendChild(t);
      log.appendChild(quick);
      scrollLog();
      setTimeout(function () {
        t.classList.remove('msg--typing');
        t.innerHTML = '';
        t.textContent = text;
        stampTime(t);
        scrollLog();
        state.busy = false;
        var panelHidden = isRail() ? !state.deskOpen : !state.open;
        if (panelHidden && fabDot) fabDot.hidden = false;
        resolve();
      }, delay || 700);
    });
  }

  /* Кнопок у чаті немає — варіанти лишаються тільки як підказка в полі
     вводу, а відповідь користувач пише текстом. Збіг шукаємо за назвою
     варіанта; не збіглося — приймаємо відповідь як вільний текст. */
  function matchOption(items, v) {
    var low = String(v).toLowerCase().trim();
    for (var i = 0; i < items.length; i++) {
      var lbl = String(items[i].label).toLowerCase();
      if (low === lbl || lbl.indexOf(low) === 0 || low.indexOf(lbl) === 0) return items[i];
    }
    return null;
  }

  function setQuick(items, handler) {
    quick.innerHTML = '';
    var hint = items.map(function (it) { return it.label; }).join(' / ');
    if (hint.length <= 70) setPlaceholder(hint);
    onText = function (v) {
      var hit = matchOption(items, v);
      markStarted();
      handler({ label: v, value: hit ? hit.value : v });
    };
    scrollLog();
  }

  function setPlaceholder(ph) { input.placeholder = ph; }

  var onText = null; // поточний обробник текстового вводу

  function submitText() {
    if (state.busy) return;
    var v = input.value.trim();
    if (!v) return;
    input.value = '';
    input.classList.remove('is-bad');
    if (onText) onText(v);
  }
  form.addEventListener('submit', function (e) { e.preventDefault(); submitText(); });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); submitText(); }
  });

  function markStarted() {
    if (!state.started) {
      state.started = true;
      if (fabLabel) fabLabel.textContent = L.fabGo;
    }
  }

  /* --- кроки сценарію --- */
  function start() {
    botSay(L.greet1, 800)
      .then(function () { return botSay(L.greet2, 900); })
      .then(askArea);
  }

  function areaItems() {
    return L.areas.map(function (a) { return { label: a.label, value: a.id }; });
  }

  function classify(text) {
    var low = String(text).toLowerCase();
    var best = null;
    Object.keys(L.classify).some(function (id) {
      var hit = L.classify[id].some(function (kw) { return low.indexOf(kw) !== -1; });
      if (hit) { best = id; return true; }
      return false;
    });
    return best;
  }

  function areaById(id) {
    for (var i = 0; i < L.areas.length; i++) if (L.areas[i].id === id) return L.areas[i];
    return null;
  }

  function askArea() {
    state.step = 'area';
    setPlaceholder(L.inputPh);
    setQuick(areaItems(), function (it) {
      markStarted();
      userSay(it.label);
      pickArea(it.value);
    });
    onText = function (v) {
      markStarted();
      userSay(v);
      state.data.firstText = v;
      var id = classify(v);
      if (id) {
        var a = areaById(id);
        botSay(L.detected(a.label)).then(function () {
          setQuick([
            { label: L.yes, value: 'yes' },
            { label: L.pickOther, value: 'no' }
          ], function (it) {
            userSay(it.label);
            if (it.value === 'yes') { pickArea(id); }
            else { botSay(L.greet2).then(askArea); }
          });
        });
      } else {
        botSay(L.cantDetect).then(function () {
          setQuick(areaItems(), function (it) {
            userSay(it.label);
            pickArea(it.value);
          });
        });
      }
    };
  }

  function pickArea(id) {
    var a = areaById(id) || { id: id, label: id };
    state.data.area = a.id;
    state.data.areaLabel = a.label;
    progress();
    askDetail();
  }

  function askDetail() {
    var d = L.details[state.data.area];
    if (!d) { progress(); askUrgency(); return; }
    state.step = 'detail';
    botSay(d.q).then(function () {
      setQuick(d.opts.map(function (o) { return { label: o, value: o }; }), function (it) {
        userSay(it.label);
        state.data.detail = it.value;
        progress();
        askUrgency();
      });
      onText = function (v) {
        userSay(v);
        state.data.detail = v;
        quick.innerHTML = '';
        progress();
        askUrgency();
      };
    });
  }

  function askUrgency() {
    state.step = 'urgency';
    botSay(L.urgencyQ).then(function () {
      setQuick(L.urgency.map(function (o) { return { label: o, value: o }; }), function (it) {
        userSay(it.label);
        state.data.urgency = it.value;
        progress();
        askCity();
      });
    });
  }

  function askCity() {
    state.step = 'city';
    botSay(L.cityQ).then(function () {
      setPlaceholder(L.cityPh);
      input.focus();
      onText = function (v) {
        if (v.length < 2) { input.classList.add('is-bad'); botSay(L.cityBad); return; }
        userSay(v);
        state.data.city = v;
        progress();
        askBudget();
      };
    });
  }

  function askBudget() {
    state.step = 'budget';
    setPlaceholder(L.inputPh);
    botSay(L.budgetQ).then(function () {
      setQuick(L.budget.map(function (o) { return { label: o, value: o }; }), function (it) {
        userSay(it.label);
        state.data.budget = it.value;
        progress();
        askDescribe();
      });
    });
  }

  function askDescribe() {
    if (state.data.firstText && state.data.firstText.length > 15) {
      state.data.description = state.data.firstText;
      progress();
      analyze();
      return;
    }
    state.step = 'describe';
    botSay(L.descQ).then(function () {
      setPlaceholder(L.descPh);
      input.focus();
      setQuick([{ label: L.skip, value: '' }], function () {
        progress();
        analyze();
      });
      onText = function (v) {
        userSay(v);
        state.data.description = v;
        quick.innerHTML = '';
        progress();
        analyze();
      };
    });
  }

  function analyze() {
    state.step = 'analyze';
    setPlaceholder(L.inputPh);
    onText = null;
    botSay(L.analyzing, 1400)
      .then(function () { return botSay(L.summary(state.data), 900); })
      .then(function () { return botSay(L.analysis(state.data.areaLabel, state.data.city), 1000); })
      .then(askName);
  }

  function askName() {
    state.step = 'name';
    botSay(L.nameQ).then(function () {
      setPlaceholder(L.namePh);
      input.focus();
      onText = function (v) {
        if (v.length < 2) { input.classList.add('is-bad'); botSay(L.nameBad); return; }
        userSay(v);
        state.data.name = v;
        progress();
        askContact();
      };
    });
  }

  function askContact() {
    state.step = 'contact';
    botSay(L.contactQ(state.data.name)).then(function () {
      setPlaceholder(L.contactPh);
      input.focus();
      onText = function (v) {
        if (!isContact(v)) { input.classList.add('is-bad'); botSay(L.contactBad); return; }
        userSay(v);
        state.data.contact = v;
        progress();
        finish();
      };
    });
  }

  function finish() {
    state.step = 'done';
    var d = state.data;
    submitLead({
      source: 'chat',
      area: d.area, areaLabel: d.areaLabel, detail: d.detail || '',
      urgency: d.urgency || '', city: d.city || '', budget: d.budget || '',
      description: d.description || d.firstText || '',
      name: d.name, contact: d.contact
    }).then(function () {
      if (fabLabel) fabLabel.textContent = L.fabDone;
      return botSay(L.done(d.name), 1100);
    }).then(function () {
      return botSay(L.done2, 900);
    }).then(function () {
      /* За ТЗ кваліфікації далі — сторінка подяки з 4 питаннями. */
      setTimeout(function () { if (THANKS_URL) if (THANKS_URL) location.href = THANKS_URL; }, 1400);
    }).catch(function () {
      state.step = 'contact';
      botSay(lang === 'en'
        ? 'Sorry, the security check failed. Please try sending your contact again.'
        : 'Вибачте, перевірка безпеки не пройшла. Будь ласка, введіть контакт ще раз.');
    });
  }

  /* --- режими показу: десктоп ≥1200px — велика фіксована панель у правій
     частині екрана, відкрита одразу, згортається в круглу бульбашку.
     Мобільний — чат стоїть першим екраном сторінки (у потоці): гортаєш
     униз, далі йде лендінг, а коли чат пішов з очей, знизу зʼявляється
     плашка і повертає до нього. --- */
  var mqRail = window.matchMedia('(min-width: 1200px)');
  function isRail() { return mqRail.matches; }

  /* Реальна висота хедера → CSS-змінна: на десктопі панель не заходить
     на хедер, на мобільному з цього рахується висота першого екрана */
  var headerEl = document.querySelector('header.site');
  function setHdrVar() {
    var h = headerEl ? headerEl.offsetHeight : 65;
    document.documentElement.style.setProperty('--hdr-h', h + 'px');
  }
  setHdrVar();
  window.addEventListener('load', setHdrVar);

  var dim = document.getElementById('chatDim');

  function scrollToChat(focus) {
    var y = chat.getBoundingClientRect().top + window.pageYOffset - (headerEl ? headerEl.offsetHeight : 65);
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    if (focus) setTimeout(function () { input.focus(); }, 420);
  }

  /* «Згорнути» на мобільному = піти до лендінгу під чатом */
  function scrollPastChat() {
    var y = chat.getBoundingClientRect().bottom + window.pageYOffset - (headerEl ? headerEl.offsetHeight : 65);
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  function applyMode() {
    if (!isRail() || !state.deskOpen) state.wide = false;
    if (isRail()) {
      chat.classList.toggle('is-collapsed', !state.deskOpen);
      if (fab) fab.hidden = state.deskOpen;
      if (state.deskOpen && fabDot) fabDot.hidden = true;
    } else {
      chat.classList.remove('is-collapsed');
      syncFab();
    }
    chat.classList.toggle('is-wide', state.wide);
    if (dim) dim.hidden = !state.wide;
    followFooter();
    scrollLog();
  }

  /* Плашка знизу: на мобільному зʼявляється, лише коли чат лишився ВИЩЕ —
     тобто його вже проминули. Поки чат попереду (перший екран — оффер із
     власною кнопкою «Chat»), плашка тільки дублювала б цю кнопку. */
  function chatPassed() {
    return chat.getBoundingClientRect().bottom <= 90;
  }
  function syncFab() {
    if (!fab || isRail()) return;
    var away = chatPassed();
    fab.hidden = !away;
    if (!away && fabDot) fabDot.hidden = true;
  }

  /* Клік по чату (десктоп) розгортає його ширше і пригасає сторінку;
     клік по затемненню, Esc або кнопка згортання повертають назад */
  function setWide(v) {
    state.wide = !!v && isRail() && state.deskOpen;
    applyMode();
  }
  chat.addEventListener('click', function (e) {
    if (!isRail() || state.wide) return;
    if (e.target.closest('.chat-min') || e.target.closest('.cx-tel')) return;
    setWide(true);
  });
  if (dim) dim.addEventListener('click', function () { setWide(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.wide) setWide(false);
  });
  function openPanel() {
    if (isRail()) { state.deskOpen = true; applyMode(); return; }
    scrollToChat(true);
  }
  function closePanel() {
    if (isRail()) { state.deskOpen = false; applyMode(); return; }
    scrollPastChat();
  }

  /* Зупинка біля футера (тільки десктоп): щойно чорний футер зʼявляється
     знизу, панель і бульбашка зсуваються вгору разом зі сторінкою. */
  var footerEl = document.querySelector('footer.cabf');
  function followFooter() {
    var shift = '';
    if (isRail() && !state.wide && footerEl) {
      var overlap = Math.max(0, window.innerHeight - footerEl.getBoundingClientRect().top);
      if (overlap > 0) shift = 'translateY(-' + Math.round(overlap) + 'px)';
    }
    chat.style.transform = shift;
    if (fab) fab.style.transform = shift;
  }
  window.addEventListener('scroll', function () { followFooter(); syncFab(); }, { passive: true });

  /* Клавіатура на мобільному: поле піднімаємо, лише якщо його справді
     не видно — інакше фокус перебиває щойно зроблену прокрутку до чату */
  input.addEventListener('focus', function () {
    if (isRail()) return;
    setTimeout(function () {
      var vv = window.visualViewport;
      var limit = vv ? vv.height : window.innerHeight;
      var r = input.getBoundingClientRect();
      if (r.bottom > limit - 8 || r.top < 60) input.scrollIntoView({ block: 'center' });
    }, 300);
  });

  window.addEventListener('resize', function () { setHdrVar(); applyMode(); followFooter(); });
  if (mqRail.addEventListener) mqRail.addEventListener('change', applyMode);

  if (minBtn) minBtn.addEventListener('click', function () {
    /* у розгорнутому стані перший клік повертає до компактної панелі */
    if (isRail() && state.wide) { setWide(false); return; }
    closePanel();
  });
  if (fab) fab.addEventListener('click', function () { scrollToChat(false); });

  /* Бейдж «1» на плашці, поки розмову не почато */
  setTimeout(function () {
    if (!state.started && fab && !fab.hidden && fabDot) fabDot.hidden = false;
  }, 4000);

  /* «Передзвоніть мені»: короткий флоу — одразу імʼя і контакт */
  var cbBtn = document.getElementById('chatCallback');
  if (cbBtn) cbBtn.addEventListener('click', function () {
    openPanel();
    if (state.step === 'area' && !state.busy) {
      markStarted();
      userSay(L.cbLabel);
      quick.innerHTML = '';
      state.data.area = 'callback';
      state.data.areaLabel = L.cbArea;
      state.data.detail = L.cbArea;
      progress();
      botSay(L.cbAsk).then(askName);
    } else if (isRail()) {
      input.focus();
    }
  });

  /* «Заявка формою» всередині чату: на мобільному спершу закриваємо
     фулскрін-панель, інакше якір відкриється під нею */
  var formLink = document.querySelector('.cx-crow .cx-form');
  if (formLink) formLink.addEventListener('click', function () {
    if (!isRail()) closePanel();
  });

  /* Кнопки «відкрити чат» і картки напрямів */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-chat-open]');
    var areaBtn = e.target.closest('[data-chat-area]');
    if (!opener && !areaBtn) return;
    e.preventDefault();
    if (areaBtn && state.step === 'area' && !state.busy) {
      var id = areaBtn.getAttribute('data-chat-area');
      var a = areaById(id);
      if (a) {
        markStarted();
        userSay(a.label);
        quick.innerHTML = '';
        pickArea(id);
      }
    }
    openPanel();
    if (isRail()) input.focus();
  });

  applyMode();
  start();

  /* ------------------------------------------------ форма ---- */
  var leadForm = document.getElementById('leadForm');
  if (leadForm) {
    leadForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var name = leadForm.querySelector('[name="name"]');
      var contact = leadForm.querySelector('[name="contact"]');
      var ok = true;
      if (!name.value.trim() || name.value.trim().length < 2) { name.classList.add('is-bad'); ok = false; }
      else name.classList.remove('is-bad');
      if (!isContact(contact.value)) { contact.classList.add('is-bad'); ok = false; }
      else contact.classList.remove('is-bad');
      if (!ok) return;
      var f = new FormData(leadForm);
      var areaSel = leadForm.querySelector('[name="area"] option:checked');
      var submitButton = leadForm.querySelector('[type="submit"]');
      if (submitButton) submitButton.disabled = true;

      submitLead({
        source: 'form',
        area: String(f.get('area') || ''),
        areaLabel: areaSel ? areaSel.textContent : '',
        urgency: String(f.get('urgency') || ''),
        city: String(f.get('city') || ''),
        budget: '',
        description: String(f.get('description') || ''),
        name: String(f.get('name') || '').trim(),
        contact: String(f.get('contact') || '').trim()
      }).then(function () {
        /* За ТЗ кваліфікації подяка — окрема сторінка з 4 питаннями. */
        if (THANKS_URL) location.href = THANKS_URL;
      }).catch(function () {
        if (submitButton) submitButton.disabled = false;
        alert(lang === 'en'
          ? 'Security check failed. Please try again.'
          : 'Перевірка безпеки не пройшла. Спробуйте ще раз.');
      });
    });
  }

  /* ------------------------------------------------ демо підбору ---- */
  var matchCard = document.getElementById('matchCard');
  if (matchCard && 'IntersectionObserver' in window) {
    var mio = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        matchCard.classList.add('in');
        mio.disconnect();
      }
    }, { threshold: 0.4 });
    mio.observe(matchCard);
  }
  /* ------------------------------------------------ телефон ---- */
  /* Номер живе в window.LEAD_CONFIG — розкладаємо його по всіх [data-tel]
     (кнопка «Call» у героєві, іконка трубки в чаті), щоб правити в одному
     місці. На телефоні tel: відкриває набирач; на десктопі набирача зазвичай
     немає, тому клік копіює номер у буфер і показує підтвердження. */
  var telCfg = window.LEAD_CONFIG || {};
  var telNodes = document.querySelectorAll('[data-tel]');
  if (telCfg.phone) {
    Array.prototype.forEach.call(telNodes, function (el) {
      el.setAttribute('href', 'tel:' + telCfg.phone);
      var label = el.querySelector('[data-tel-label]');
      if (label && telCfg.phoneLabel) label.textContent = telCfg.phoneLabel;
    });
  }

  /* Пристрій уміє дзвонити? Груба вказівка без hover — телефон чи планшет. */
  var canDial = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

  function flashCopied(el) {
    if (el.dataset.telBusy) return;
    el.dataset.telBusy = '1';
    el.classList.add('is-copied');
    /* [data-tel-text] — увесь підпис кнопки: підміняємо його цілком, інакше
       вийде «Call Number copied». В іконки трубки підпису немає — там
       підтвердження малює CSS через ::after. */
    var text = el.querySelector('[data-tel-text]');
    var prev = text ? text.innerHTML : null;
    if (text) text.textContent = el.getAttribute('data-tel-copied') || 'Copied';
    setTimeout(function () {
      if (text) text.innerHTML = prev;
      el.classList.remove('is-copied');
      delete el.dataset.telBusy;
    }, 1600);
  }

  /* Запасний шлях: clipboard API падає без явного жесту або на http:// */
  function legacyCopy(num) {
    var tmp = document.createElement('textarea');
    tmp.value = num;
    tmp.setAttribute('readonly', '');
    tmp.style.cssText = 'position:fixed;top:-1000px;opacity:0';
    document.body.appendChild(tmp);
    tmp.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (err) { ok = false; }
    document.body.removeChild(tmp);
    return ok;
  }

  function copyPhone(el) {
    var num = (el.getAttribute('href') || '').replace(/^tel:/, '');
    if (!num) return;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(num).then(
        function () { flashCopied(el); },
        function () { if (legacyCopy(num)) flashCopied(el); }
      );
      return;
    }
    if (legacyCopy(num)) flashCopied(el);
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-tel]');
    if (!el || canDial) return;   /* на телефоні не заважаємо набирачу */
    e.preventDefault();
    copyPhone(el);
  });

})();